var EHDI = EHDI || Object.create(null);

EHDI.component = EHDI.component || Object.create(null);

EHDI.component.ReelSession = function() {
    EHDI.aka.Container.call(this);
	
    var _this = this;
        
	var REEL_MAX = 100;
	_this.BASE_STRENGTH = 45;
	
	var _objectData;
	var _catchType = -1;
	
	
    var _time = 0,
		_reelProgress = 0,
        _reelAnimType = -1,
		
		_playerReelRate = 0,
        _baseFishStrength = 0,
		_fishStrength = 0,
		
		_baseThrashStrength = 0,
		_curThrashStrength = 0,
		_curReelStrength = 0,
		_reelWindow = 0,
        _padding = 0,
		
        _showPlaque = false,
		_inSession = false,
        _inMissed = false,
        _inResults = false,
        _canFail = true;
    
    var _progressBar, _fishline, _fishTrack, _progressBarHolder;
    var _baseFishline, _progressRange;
    
    var _resultContainer = new EHDI.aka.Container();
    var _resultTimeline = new TimelineMax( { autoRemoveChildren: true } );
    EHDI.GAME.gameScene.pauseManager.addTimelineInterrupt( _resultTimeline );
    
    var _catchContainer, _catchTxt;
    var _goGreenCon, _goTxt, _goTimeline;
    
    // temp looping sfx
    var _splashSFX = EHDI.GAME.soundManager.playSFX( "fishing_splash_loop" );
    _splashSFX.loop = -1;
    _splashSFX.stop();
    
    var createProgressBar = function(){
        _progressBar = new EHDI.aka.Sprite( EHDI.Assets.images[ "bar_bg" ] );
        _progressBar.anchor.set( 0.5, 0.5 );
        _progressBar.position.set( EHDI.screen.viewWidth * 0.925, EHDI.screen.viewHeight * 0.5 );
        _this.addChild( _progressBar );
        
        _baseFishline = _progressBar.height * 0.09;
        _progressRange = _progressBar.height * 0.712;
        
        _fishline = new EHDI.aka.Sprite( EHDI.displays.TextureRectangle( 0xFFFFFF, 2.5, _baseFishline ) );
        _fishline.anchor.set( 0.5, 0.0 );
        _fishline.position.set( _progressBar.width * 0.11, _progressBar.height * -0.43 );
        _progressBar.addChild( _fishline );
        
        _fishTrack = new EHDI.aka.Sprite( EHDI.Assets.images[ "bar_fish" ] );
        _fishTrack.anchor.set( 0.52, 0.12 );
        _fishTrack.position.x = _fishline.position.x;
        _fishTrack.position.y = _fishline.position.y + _fishline.height;
        _progressBar.addChild( _fishTrack );
        
        _progressBarHolder = new EHDI.aka.Sprite( EHDI.Assets.images[ "bar" ] );
        _progressBarHolder.anchor.set( 0.5, 0.5 );
        _progressBar.addChild( _progressBarHolder );
        _progressBar.visible = false;
    }
    
    var createCatchContainer = function(){
        _catchContainer = new EHDI.aka.Sprite( EHDI.Assets.images[ "WB_con_note" ] );
        _catchContainer.anchor.set( 0.5, 0.5 );
        _catchContainer.position.set( EHDI.screen.viewWidth * 0.5, EHDI.screen.viewHeight * 0.19 );
        _catchContainer.visible = false;
        _resultContainer.addChild( _catchContainer );

        var message = ( EHDI.BrowserInfo.isMobileDevice ? "mobile_" : "desktop_" ) + "gotaway";
        _catchTxt = new EHDI.aka.PixiText( EHDI.localization.strings[message].content, {
            fontFamily: "nuevastd-bold", 
            fontSize: EHDI.localization.strings[message].size, 
            align: 'center', 
            wordWrap: true,
            wordWrapWidth: _catchContainer.width * 0.82,
            fill: '#000000' 
        });
        _catchTxt.anchor.set( 0.5, 0.5 );
        _catchContainer.addChild( _catchTxt );
    }
    
    var createGoGreen = function(){
        _goGreenCon = new EHDI.aka.Sprite( EHDI.Assets.images[ "go_green" ] );
        _goGreenCon.anchor.set( 0.5, 0.5 );
        _goGreenCon.position.set( EHDI.screen.viewWidth * 0.215, EHDI.screen.viewHeight * 0.5 );
        _goGreenCon.visible = false;
        _resultContainer.addChild( _goGreenCon );
        
        _goTimeline = new TimelineMax( {repeat : -1} );
        _goTimeline.add( TweenMax.to( _goGreenCon, 14, { rotation: -2 * Math.PI, ease:Linear.easeNone } ) );
        EHDI.GAME.gameScene.pauseManager.addTimelineInterrupt( _goTimeline );
        
        _goTxt = new EHDI.aka.PixiText( EHDI.localization.strings["gogreen"].content, {
            fontFamily: "nuevastd-bold", 
            fontSize: EHDI.localization.strings["gogreen"].size, 
            align: 'center',
            fill: '#FFFFFF',
            dropShadow : true,
            dropShadowBlur: 8,
            dropShadowColor : '#000000',
            dropShadowAngle : Math.PI / 4,
            dropShadowDistance : 10
        });
        _goTxt.anchor.set( 0.48, 0.48 );
        _goTxt.position.set( EHDI.screen.viewWidth * 0.215, EHDI.screen.viewHeight * 0.5 );
        _goTxt.visible = false;
        _resultContainer.addChild( _goTxt );
    }
    
    createProgressBar();
    _this.addChild( _resultContainer );
    createCatchContainer();
    createGoGreen();
    
	this.update = function( dt ){
		if( !_inSession ) return;
		if( _splashSFX.playState !== "playSucceeded" ) _splashSFX.play();
        
		_time += dt;
		if( _time >= _spikeInterval ){
			_time = 0;
            
			if( _fishStrength !== _baseFishStrength ){
				_fishStrength = _baseFishStrength;
				_spikeInterval = EHDI.NumberUtil.randomRange( 1.75, 4.25 );
			}
			else{
				_fishStrength += EHDI.NumberUtil.randomRange( _baseFishStrength * -0.2, _baseFishStrength * 0.075 );
				_spikeInterval = EHDI.NumberUtil.randomRange( 0.5, 1.5 );
			}
		}
        
        _reelProgress += _fishStrength * dt;
        if( !_canFail && _reelProgress < 8 ) _reelProgress = 8;
        
        if( _reelProgress < 18 ){
            if( _reelAnimType !== 0 ){
                _reelAnimType = 0;
                EHDI.GAME.gameScene.updateReelAnim( 0 );
            }
        }
        else if( _reelProgress > 82 ){
            if( _reelAnimType !== 2 ){
                _reelAnimType = 2;
                EHDI.GAME.gameScene.updateReelAnim( 2 );
            }
        }
        else{
            if( _reelAnimType !== 1 ){
                _reelAnimType = 1;
                EHDI.GAME.gameScene.updateReelAnim( 1 );
            }
        }
        
        if( _reelProgress > 100 ) _reelProgress = 100;
        _fishline.height = _baseFishline + ( _progressRange * ( (100 - _reelProgress) / 100 ) );
        _fishTrack.position.y = _fishline.position.y + _fishline.height;
		
		if( _reelProgress >= 100 ){
			finishReel( true );
		}
		else if( _reelProgress <= 0 ){
			finishReel( false );
		}
	}
	
	this.startSession = function( objectData, type, rarity ){
        // TODO - i'm adding objectData.windowPadding, this will adjust the start area of the green window
        // with this change, i will spawn the finger at the 50 value instead of in relation to the size of the window
		_time = 0;
		
		_objectData = objectData;
		_catchType = type;
		
		var rarityBonus = 1;
		if( rarity === 1 ) rarityBonus = 1.2;
		if( rarity === 2 ) rarityBonus = 1.3;
		
		_fishStrength = objectData.pullStrength;
        _baseFishStrength = _fishStrength;
		_playerReelRate = _this.BASE_STRENGTH - ( objectData.newWeight * objectData.strength * rarityBonus );
        _playerReelRate *= 0.6;
		
		_baseThrashStrength = 10 + ( objectData.newWeight * objectData.strength );
		_curThrashStrength = _baseThrashStrength;
		_reelWindow = objectData.window;
        _padding = objectData.windowPadding;
		
		_reelProgress = _fishStrength * 1.35;
        if( _reelProgress < 20 ) _reelProgress = 20;
		_curReelStrength = 50; // - ( _reelWindow * 0.6 );
		_spikeInterval = EHDI.NumberUtil.randomRange( 3, 6 );
        
        _fishline.height = _baseFishline + ( _progressRange * ( (100 - _reelProgress) / 100 ) );
        _fishTrack.position.y = _fishline.position.y + _fishline.height;
        
        _catchContainer.visible = false;
        _goGreenCon.visible = false;
        _goTxt.visible = false;
        
        if( type === 0 ){
            _catchContainer.visible = true;
            // TODO - check objectData.newweight, ass prefix of small/medium/large
            //var catchText = "You caught:\n";
            var catchText = EHDI.localization.strings["gencaught"].content;
            catchText = catchText.replace( "[name]", EHDI.localization.strings[ "fish_" + objectData.id ].content );
            catchText = catchText.replace( "[weight]", objectData.newWeight );
            _catchTxt.text = catchText;
            
            if( _objectData.newWeight >= _objectData.baseWeight * 2 &&
                EHDI.GAME.dataManager.getData().fish[ objectData.id ].weight < _objectData.baseWeight * 2 ) 
                _showPlaque = true;
        }
        else if( type === 1 ){
            //_catchTxt.text = "You caught: " + objectData.name + "\n" + objectData.desc + "";
            var catchText = EHDI.localization.strings["powcaught"].content;
            catchText = catchText.replace( "[name]", EHDI.localization.strings[ "pow_name_" + objectData.id ].content );
            catchText = catchText.replace( "[desc]", EHDI.localization.strings[ "pow_desc_" + objectData.id ].content );
            _catchTxt.text = catchText;
            _catchContainer.visible = true;
        }
        else if( type === 2 ){
            _goGreenCon.visible = true;
            _goTxt.visible = true;
        }
        
        _this.setReelElementsVisible( true );
        _this.setResultsVisible( false );
        _reelAnimType = -1;
        _inSession = true;
        
        var achieveStatus = EHDI.GAME.achieveManager.getUnlockedStates();
        _canFail = achieveStatus[ 0 ];
	}
    
    this.reelNothing = function(){
        _reelAnimType = -1;
        _catchType = -1;
        _this.setReelElementsVisible( false );
        _catchContainer.visible = true;
        _goGreenCon.visible = false;
        _goTxt.visible = false;
        _catchTxt.text = EHDI.localization.strings["nothing"].content;
    }
    
    this.reelEscape = function(){
        _reelAnimType = -1;
        _this.setReelElementsVisible( false );
        _catchContainer.visible = true;
        _goGreenCon.visible = false;
        _goTxt.visible = false;
        _resultContainer.visible = true;
        _catchTxt.text = EHDI.localization.strings["toolate"].content;
        _inMissed = true;
        
    }
	
	this.reelFish = function(){
		if( _inSession ){
            _reelProgress += 7;
        }
        else if( _inResults ){
            if( _showPlaque ){
                EHDI.GAME.achieveManager.updateHeavyCatch();
                EHDI.GAME.achieveManager.updateRecord( _objectData.id );
                // add popup ot mention all achievements unlocked, check in resetstate(debating it still?)
                
                _showPlaque = false;
                EHDI.GAME.gameScene.pauseManager.isPaused = true;
                EHDI.GAME.sceneManager.pushPopUp(
                    new EHDI.popup.PlaquePopup( EHDI.localization.strings[ "fish_" + _objectData.id ].content, _objectData.newWeight, _objectData.asset ), 
                    {y : new EHDI.scene.TransitionParameter(- EHDI.screen.stageHeight, 0), duration : 0.2}
                );
            }
            
            _this.setResultsVisible( false );
            EHDI.GAME.gameScene.endReelSession();
        }
        else if( _inMissed ){
            _inMissed = false;
            _this.setResultsVisible( false );
            EHDI.GAME.gameScene.resetState();
        }
	}
    
    this.setReelElementsVisible = function( status ){
        _progressBar.visible = status;
    }
    
    this.setResultsVisible = function( status ){
        _inResults = status;
        _resultContainer.visible = status;
        
        if( status ){
            if( _resultTimeline ){
                _resultTimeline.kill();
                _resultTimeline.clear();
            }
            
            if( _catchType === 0 || _catchType === 1 ){
                _resultTimeline.add( TweenMax.from( _catchContainer, 0.2, {y: EHDI.screen.viewHeight * -0.1} ) );
            }
            else if( _catchType === 2 ){
                _resultTimeline.add( TweenMax.from( _goGreenCon, 0.2, {scaleX: 0, scaleY: 0} ) );
            }
        }
    }
	
	var finishReel = function( didCatch ){
        _this.reelAnimType = -1;
		_inSession = false;
        _this.setReelElementsVisible( false );
		
        _splashSFX.stop();
		if( didCatch ){
            EHDI.GAME.soundManager.playSFX( "fish_caught" );
            
			if( _catchType === 0 ){
                EHDI.GAME.dataManager.addCaughtFish( _objectData );
                EHDI.GAME.achieveManager.updateFirstCatch();
                EHDI.GAME.achieveManager.updateFishCaught( _objectData.id );
            }
			else if( _catchType === 1 ){
                EHDI.GAME.dataManager.addCaughtPowerup( _objectData );
                EHDI.GAME.achieveManager.updatePowerCaught( _objectData.id );
            }
			else if( _catchType === 2 ){
                EHDI.GAME.dataManager.addCaughtJunk( _objectData );
                EHDI.GAME.achieveManager.updateJunkCaught( _objectData.id );
            }
		}
        
        if( !didCatch ){
            EHDI.GAME.soundManager.playSFX( "fish_caught" );
            
            _showPlaque = false;
            _catchContainer.visible = true;
            _goGreenCon.visible = false;
            _goTxt.visible = false;
            
            var message = ( EHDI.BrowserInfo.isMobileDevice ? "mobile_" : "desktop_" ) + "gotaway";
            _catchTxt.text = EHDI.localization.strings[message].content;
        }
        
        EHDI.GAME.gameScene.catchResult( didCatch );
	}
    
    this.onResize = function(){
        _progressBar.position.set( EHDI.screen.viewWidth * 0.925, EHDI.screen.viewHeight * 0.5 );
        _catchContainer.position.set( EHDI.screen.viewWidth * 0.5, EHDI.screen.viewHeight * 0.19 );
        _goGreenCon.position.set( EHDI.screen.viewWidth * 0.215, EHDI.screen.viewHeight * 0.5 );
        _goTxt.position.set( EHDI.screen.viewWidth * 0.215, EHDI.screen.viewHeight * 0.5 );
    }
    
    this.dispose = function(){
        EHDI.GAME.gameScene.pauseManager.removeTimelineInterrupt( _resultTimeline );
        EHDI.GAME.gameScene.pauseManager.removeTimelineInterrupt( _goTimeline );
    }
}

EHDI.component.ReelSession.prototype = Object.create(EHDI.aka.Container.prototype);